import React from "react";
import { FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const BlackButton = (props) => {
  const { text, to, email, onclick, disabled } = props;
  return (
    <Link to={to} state={{ email: email ? email : "" }}>
      <button
        style={props.style}
        onClick={onclick}
        disabled={disabled}
        className="font-thicboi text-base font-semibold text-white 
        py-2 pl-6 pr-3 md:py-3 border border-[#9B8AFB] rounded-[24px] cursor-pointer
        group flex gap-2 items-center justify-center"
      >
        <p>{text}</p>
        {props.noArrow ? null : <FaChevronRight
          color="#fff"
          className="invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-opacity duration-300"
        />}
      </button>
    </Link>
  );
};

export default BlackButton;
